export const ON_LOGOUT_OKTA = 'Application/ON_LOGOUT_OKTA'
export const ON_LOGOUT_OKTA_ERROR = 'Application/ON_LOGOUT_OKTA_ERROR'
export const ON_LOGOUT_OKTA_SUCCESS = 'Application/ON_LOGOUT_OKTA_SUCCESS'


export const ON_LOGOUT_OAG = 'Application/ON_LOGOUT_OAG'
export const ON_LOGOUT_OAG_ERROR = 'Application/ON_LOGOUT_OAG_ERROR'
export const ON_LOGOUT_OAG_SUCCESS = 'Application/ON_LOGOUT_OAG_SUCCESS'
export const ON_CP_SESSION_OUT_EVENT_LOGGED = 'Application/ON_CP_SESSION_OUT_EVENT_LOGGED'
